// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./front/front.scss
// module id = 4
// module chunks = 1